function checkFeatureFlag(featureFlagName: string) {
  const featureFlag = process.env[`REACT_APP_${featureFlagName.toUpperCase()}`];
  return featureFlag && featureFlag === "true";
}

export default checkFeatureFlag;
